<template>
    <div v-if="show" id="only-read-buttons">
        <div @click="handleOpenBookViewer">
            <span>{{ openViewerTxt }}</span>
        </div>
        <div @click="handleExitApp">
            <span>{{ exitTxt }}</span>
        </div>
    </div>
</template>

<script>
import { store } from "../../store";
import AppRenderer from "../../js/app_renderer";
import BookData from "../../js/book_data";

export default {
    name: "OnlyReadButtons",
    data() {
        return {
            // show: true,
            openViewerTxt: "開啟電子書",
            exitTxt: "離開",
        };
    },
    computed: {
        show() {
            return store.onlyRead;
        },
    },
    created() {
        // this.show = store.onlyRead;
    },
    methods: {
        /**
         * 開啟閱讀器
         */
        handleOpenBookViewer() {
            const path = `${BookData.Instance.AppPath}/ebookViewer/ebook_viewer.exe`;
            AppRenderer.Instance.openFile(path);
        },
        /**
         * 關閉周邊資源
         */
        handleExitApp() {
            AppRenderer.Instance.exit();
        },
    },
};
</script>

<style lang="css" scoped>
#only-read-buttons {
    display: flex;
    position: absolute;
    z-index: var(--z-index-only-read-buttons);
    width: 400px;
    flex-direction: row;
    justify-content: space-evenly;
    bottom: 50px;
    right: 50px;
}

#only-read-buttons div {
    background: linear-gradient(white, gray, #303030);
    color: white;
    font-weight: bold;
    font-size: 1.5rem;
    padding: 10px 20px 10px 20px;
    border-radius: 1rem;
}
#only-read-buttons div:hover {
    background: linear-gradient(white, rgb(107, 107, 252), blue);
}
</style>
